<template>
  <aside v-if="!noChallenges" class="widget currentContent">
    <div v-if="errorText === ''">
      <h4>{{title}}</h4>
      <div class="px-2 homepage">
        <router-link class="text-primary" :to="link">
          <img class="d-block w-100 mb-2" :src="featuredIMG" alt="VE Awards 2018">
        </router-link>
        <p v-html="content"></p>
        <router-link class="text-primary" :to="link"><strong>Get involved »</strong></router-link>
      </div>
    </div>
    <div v-if="errorText !== ''" class="alert alert-warning" role="alert">
      {{errorText}}
    </div>
  </aside>
</template>

<script>
import WordpressRestAPI from '@/helpers/WordpressRestAPI.js'
export default {
  porps: [
    'postId'
  ],
  data () {
    return {
      content: '',
      featuredIMG: '',
      link: '',
      errorText: '',
      title: '',
      noChallenges: false
    }
  },
  created () {
    WordpressRestAPI.getViewContent('idea_challenge?_embed')
      .then(response => {
        if (response.data.length > 0) {
          this.title = response.data[0].title.rendered
          this.content = response.data[0].excerpt.rendered
          this.link = '/idea-challenges/idea-challenge/' + response.data[0].slug
          this.featuredIMG = response.data[0]._embedded['wp:featuredmedia'][0].media_details.sizes.medium.source_url
        } else {
          this.noChallenges = true
        }
      })
      .catch(e => {
        console.error(e)
        this.errorText = 'Unable to load latest VE Award'
      })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/CurrentIdeaChallenge.vue